import React from "react";
import styled from "styled-components";
// Animations
import { motion } from "framer-motion";
import { pageAnimation, titleAnimation } from "../animation";
import { Hide } from "../styles";

const TeamStyle = styled(motion.section)`
  padding: 5rem;
  max-height: 100vh;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  color: #f1ec0a;
  background-color: #ff1a1a;
  /* Kindel and iPad tablet  */
  @media only screen and (min-width: 540px) and (max-width: 820px) {
    padding: 5rem 2rem;
  }
  /* Mobile devices iPhone, Pixel */
  @media only screen and (min-width: 320px) and (max-width: 539px) {
    padding: 1.5rem;
    max-height: fit-content;
    height: 100%;
  }
`;

const TeamTitle = styled(motion.div)`
  width: 100%;
  h4 {
    color: #f1ec0a;
    font-size: 4rem;
  }
  p {
    color: #f1ec0a;
  }
  /* Kindel and iPad tablet  */
  @media only screen and (min-width: 540px) and (max-width: 820px) {
    h4 {
      font-size: 3.6rem;
    }
  }
  /* Mobile devices iPhone, Pixel */
  @media only screen and (min-width: 320px) and (max-width: 539px) {
    h4 {
      font-size: 2.5rem;
    }
    p {
      font-size: 1rem;
    }
  }
`;

const OurTeam = () => {
  return (
    <TeamStyle
      variants={pageAnimation}
      initial="hidden"
      animate="show"
      exit="exit"
    >
      <TeamTitle variants={titleAnimation}>
        <Hide>
          <motion.h4>Our Team</motion.h4>
          <motion.p>
            At Burgred, we believe that exceptional quality starts with exceptional people. Our staff is highly trained to deliver not just great food, but an outstanding experience for every guest. To ensure that every team member is fully equipped to uphold the high standards we set, each new staff member must undergo a rigorous 15 to 30 days training program before officially joining the team.
          </motion.p>
          <motion.p>
            To ensure a safe and healthy working environment, all of our employees undergo medical check-ups every six months. We have partnered with a professional occupational medical center to monitor and support the health of our staff. This regular medical control ensures that every team member is in optimal condition to serve you with energy and care.
          </motion.p>
          <motion.p>
            In addition to perfecting their culinary skills, our team members are trained in exceptional customer service, ensuring they provide the welcoming and attentive experience Burgred is known for. Whether it's explaining the sourcing of ingredients or recommending the perfect burger to match a guest's taste, our staff is knowledgeable, passionate, and ready to provide personalized service.
          </motion.p>
          <motion.p>
            By investing in their development, we ensure that every member of the Burgred team is not only a part of the family, but also a true expert in crafting the perfect burger or french tacos and helping our customers to discover the perfect combination that suits your unique palate.
          </motion.p>
        </Hide>
      </TeamTitle>
    </TeamStyle>
  );
};

export default OurTeam;
